export enum OrderServiceStatus {
  PENDING_RESCHEDULE = 1,
  PENDING_SCHEDULE = 2,
  PENDING_ACCEPTANCE = 3,
  PENDING_EXECUTION = 4,
  COMPLETED_UNPRODUCTIVE = 5,
  COMPLETED = 6,
  EXCLUDED = 7,
}
